












































import { C2BBindingOperationVue } from "fs-pb-vue2/vueModels/operations/sbp/C2BBindingOperationVue";
import { Component } from "vue-property-decorator";

@Component({})
export default class C2BBinding extends C2BBindingOperationVue {
  async mounted() {
    await this.init();
  }
}
